import React from 'react';
import { RenderModule } from 'holocron';

const ContentWrapper = ({ children }) => (
  <RenderModule moduleName="axp-page-wrapper" props={{ headerProps: { loginDestPage: 'https://bankpermissions-deveusw1.americanexpress.com/' } }}>
    <main className="pad-4-tb">
      {children}
    </main>
  </RenderModule>
);

export default ContentWrapper;
